module.exports = __webpack_public_path__ + "static/media/aspenInvoiceFactoring.1d00226c.png";